import { useSafeQuery } from '@gen2/hooks';
import { UseQueryOptions } from '@tanstack/react-query';
import { getContactCompanies, TContactCompaniesParams, TContactCompaniesResponse } from './api';

export enum ContactCompaniesKeys {
  getContactCompanies = 'getContactCompanies',
}

export type TContactCompaniesQueryResponse = TContactCompaniesResponse | null;

export const useContactCompaniesQuery = (
  params: TContactCompaniesParams,
  options?: UseQueryOptions<TContactCompaniesQueryResponse>,
) => {
  return useSafeQuery<TContactCompaniesQueryResponse>(
    [ContactCompaniesKeys.getContactCompanies, params['filter[search]'] ?? ''],
    async () => {
      const res = await getContactCompanies(params);
      return res?.data;
    },
    options,
  );
}; 